/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
// css
import { AccountTransferInfo } from '@views/Login/KakaoLogin/AccountTransferInfo'
import { ModalBg } from '@styles/base.style'
import { FullPopupStyle } from '@styles/modal'
import { globalStore } from '@store/index'

const AccountTransferInfoPopup: React.FC = props => {
  return (
    <Modal
      popup
      transparent
      visible={globalStore.visibleAccountTransferPopup}
      maskClosable={false}
      animated={false}
      className={!isMobile ? 'pc full-modal adv-new-dialog' : 'full-modal adv-new-dialog'}
      wrapClassName="ant-popover"
      css={FullPopupStyle}
    >
      <AccountTransferInfo/>
      <ModalBg/>
    </Modal>
  )
}

export default observer(AccountTransferInfoPopup)
